import React from 'react';


const CATEGORIES = [
  { key: 'all', label: 'All Articles', icon: '📚' },
  { key: 'bail_process', label: 'Bail Process', icon: '⚖️' },
  { key: 'legal_rights', label: 'Legal Rights', icon: '📜' },
  { key: 'family_support', label: 'Family Support', icon: '❤️' },
  { key: 'sacramento_news', label: 'Sacramento News', icon: '📰' }
];

export default function CategoryFilter({ selectedCategory, onCategoryChange, categoryCounts }) {
  return (
    <div className="mb-8" role="navigation" aria-label="Article categories">
      <h2 className="sr-only">Filter articles by category</h2>
      <div className="flex flex-wrap gap-3">
        {CATEGORIES?.map(category => {
          const count = category?.key === 'all' 
            ? Object.values(categoryCounts)?.reduce((sum, val) => sum + val, 0)
            : categoryCounts?.[category?.key] || 0;
          
          const isSelected = selectedCategory === category?.key;

          return (
            <button
              key={category?.key}
              onClick={() => onCategoryChange(category?.key)}
              className={`
                inline-flex items-center px-4 py-2 rounded-lg font-medium transition-all
                ${isSelected 
                  ? 'bg-blue-600 text-white shadow-md transform scale-105' 
                  : 'bg-white text-gray-700 hover:bg-blue-50 border border-gray-300'
                }
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              `}
              aria-pressed={isSelected}
              aria-label={`Filter by ${category?.label}${count > 0 ? `, ${count} articles` : ''}`}
            >
              <span className="mr-2" aria-hidden="true">{category?.icon}</span>
              <span>{category?.label}</span>
              {count > 0 && (
                <span 
                  className={`
                    ml-2 px-2 py-0.5 rounded-full text-xs font-semibold
                    ${isSelected ? 'bg-blue-700' : 'bg-gray-200 text-gray-700'}
                  `}
                  aria-label={`${count} articles`}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}